import { render, staticRenderFns } from "./CommonSubdistrictSelector.vue?vue&type=template&id=31d28705&lang=pug&"
import script from "./CommonSubdistrictSelector.vue?vue&type=script&lang=ts&"
export * from "./CommonSubdistrictSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CommonSubdistrictSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports